import { render, staticRenderFns } from "./TemplateFacture.vue?vue&type=template&id=5416ca49&scoped=true&"
import script from "./TemplateFacture.vue?vue&type=script&lang=js&"
export * from "./TemplateFacture.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFacture.vue?vue&type=style&index=0&id=5416ca49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416ca49",
  null
  
)

export default component.exports